/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  ComponentType,
  MouseEventHandler,
  useRef,
  useState
} from 'react'
import { LayoutProps } from '@jsonforms/core'
import {
  JsonFormsDispatch,
  JsonFormsStateContext,
  withJsonFormsContext
} from '@jsonforms/react'
import './styles.scss'
import DeleteCardConfirmationModal from '../../Components/DeleteCardConfirmationModal'
import { useAppSelector } from 'hooks/store'
import { MatterClientPortalQuestionnaireSectionStatus } from 'share/domain/case'

interface DispatchPropsOfCardRenderer {
  onRemove(): () => void
}

export interface CardRendererProps
  extends LayoutProps,
    DispatchPropsOfCardRenderer {
  index: number
  dataLength: number
  isVisible: boolean
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const CardRenderer = (props: CardRendererProps) => {
  const { uischema, schema, path, renderers, cells, onRemove, dataLength } =
    props
  const elements = uischema.options?.['detail']['elements']
  const activeSection = useAppSelector((state) => state.activeSection)
  const activeSectionStatus = activeSection.section?.sectionStatus

  const isNestedQuestion = useRef(false)

  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false)

  const getDeleteButtonClassName = () => {
    return dataLength === 1
      ? 'btn btn-link disabled'
      : 'btn btn-link shadow-none'
  }

  const deleteConfirmation: MouseEventHandler<HTMLButtonElement> = (event) => {
    setShowDeleteConfirmationModal(true)
  }

  const cancelDeleteCard = () => {
    setShowDeleteConfirmationModal(false)
  }

  const itemsToRender = elements.map((element: any, index: number) => {
    const key = `item-${index}`
    if (element?.scope?.includes('navigation_')) {
      isNestedQuestion.current = true
    }
    return (
      <React.Fragment key={key}>
        {Object.keys(schema).length !== 0 &&
        Object.keys(element).length !== 0 ? (
          <JsonFormsDispatch
            schema={schema}
            uischema={element}
            path={path}
            enabled={true}
            renderers={renderers}
            cells={cells}
          />
        ) : (
          <></>
        )}
      </React.Fragment>
    )
  })
  return (
    <>
      <div className='questionnaire-card-body' style={{ marginTop: '18px' }}>
        {itemsToRender}
        {activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Submitted &&
        activeSectionStatus !==
          MatterClientPortalQuestionnaireSectionStatus.Imported ? (
          <button
            type='button'
            className={getDeleteButtonClassName()}
            onClick={deleteConfirmation}
            data-testid='card-delete-btn'
          >
            Delete Entry
          </button>
        ) : (
          <></>
        )}
      </div>
      <DeleteCardConfirmationModal
        show={showDeleteConfirmationModal}
        onHide={cancelDeleteCard}
        onSubmit={onRemove}
        isNestedQuestion={isNestedQuestion.current}
      />
    </>
  )
}

const withContextToCardRenderd =
  (
    Component: ComponentType<CardRendererProps>
  ): ComponentType<CardRendererProps> =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/display-name
  ({ ctx, props }: JsonFormsStateContext & CardRendererProps) => {
    return <Component {...props} />
  }

const withCustomProps = (Component: ComponentType<CardRendererProps>) => {
  return withJsonFormsContext(
    withContextToCardRenderd(
      React.memo(Component, (prevProps: any, props: any) => false)
    )
  )
}

export default withCustomProps(CardRenderer)
